module.exports = __webpack_public_path__ + "img/video-play.288308b.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/video-play.png
// module id = MK9D
// module chunks = 2 3